import {Component, Input, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR, ControlValueAccessor, ValidationErrors} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {CalendarModule} from 'primeng/calendar';
import {InputWrapperComponent} from '../input-wrapper/input-wrapper.component';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-input-datetime',
  standalone: true,
  imports: [
    CommonModule,
    CalendarModule,
    InputWrapperComponent,
    FormsModule
  ],
  templateUrl: './input-datetime.component.html',
  styleUrls: ['./input-datetime.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDateTimeComponent),
      multi: true
    }
  ]
})
export class InputDateTimeComponent implements ControlValueAccessor {
  @Input() label?: string;
  @Input() label2?: string;
  @Input() labelOnPress?: () => void;
  @Input() valueLabel?: string;
  @Input() required?: boolean;
  @Input() errorMessage?: ValidationErrors | null;
  @Input() touched?: boolean;
  @Input() alt?: boolean;
  @Input() onPress?: () => void;
  @Input() disabled?: boolean;
  @Input() readonly?: boolean;
  @Input() placeholder?: string = '';
  @Input() showTime?: boolean = true;
  @Input() dateFormat?: string = 'mm/dd/yy';
  @Input() showIcon?: boolean = false;
  @Input() leftIcon?: string;
  @Input() rightIcon?: string;

  value: Date | null = null;  // Date value

  onChange = (value: any) => {
  };
  onTouched = () => {
  };

  writeValue(value: Date | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleDateChange(event: Date): void {
    this.value = event;
    this.onChange(this.value);
  }
}
